import script from "./BlogButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./BlogButton.vue?vue&type=script&setup=true&lang=ts"

import "./BlogButton.vue?vue&type=style&index=0&id=a8b3d792&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a8b3d792"]])

export default __exports__